import { type RefObject } from 'react';

import { type TargetMeasurement } from './context';

// ─────────────────────────────────────────────────────────────────────────────

export type Event =
  | { type: 'scroll' }
  | { type: 'target.scrollTo'; targetId: string }
  | { type: 'target.register'; targetId: string; targetRef: RefObject<unknown> }
  | {
      type: 'target.measure';
      targetId: string;
      targetRef: RefObject<unknown>;
      measurement: TargetMeasurement;
    }
  | { type: 'target.deregister'; targetId: string }
  | { type: 'scrollView.contentSizeChange'; height: number }
  | { type: 'scrollView.layout'; height: number }
  | { type: 'defaultTarget.scrollTo'; targetId: string }
  | { type: 'defaultTarget.clear' };
